
import { defineComponent, ref } from 'vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { MEDIA_TYPES } from '@/types/enums';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  setup(props, context) {
    const isOpen = ref(false);

    function hidePopUp() {
      isOpen.value = false;
    }

    function openDriveMedia() {
      context.emit('open-drive');
      hidePopUp();
    }

    function openPhoneMedia() {
      context.emit('handle-open-phone-media', true);
      hidePopUp();
    }

    return {
      isOpen,
      MEDIA_TYPES,
      hidePopUp,
      openDriveMedia,
      openPhoneMedia,
    };
  },
});
